export default function TermsConditions() {
  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">Terms & Conditions</h1>
      <div class="policy">
        <ol start={1}>
          <li>
            <h2 className="font-bold">INTRODUCTION</h2>
            <ol>
              <li>
                By entering this promotion all participants will be deemed to
                have accepted and be bound by these full Terms and Conditions.
                All entry instructions form part of these Terms and Conditions.
                Please retain a copy for your information.
              </li>
              <li>
                This promotion is open to residents of Great Britain (England,
                Scotland, & Wales) aged 18 or over at the date on which they
                enter this promotion, except for employees of the Promoter,
                their group companies, agents, affiliates, or anyone
                professionally connected with this promotion and any member of
                their respective immediate families.
              </li>
              <li>
                Entry into this promotion opens at 00:00 on Tuesday 8
                <sup>th</sup> April 2025 and closes at 23:59 on Tuesday 20
                <sup>th</sup> May 2025 (the “Promotional Period”). Entries
                received after the Promotional Period will not be eligible to
                win a prize in either the main online promotion (Online Daily
                Prizes), the Top Tier Prize Draw, or the Mop Up Prize Draw.
              </li>
            </ol>
          </li>
          <li>
            <h2>ENTRY TO THE PROMOTION</h2>
            <ol>
              <li>
                To enter this promotion, entrants will need to do the following
                during the Promotional Period and before it ends:
                <ol>
                  <li>
                    purchase any drink from a Costa Express machine located in
                    Great Britain (England, Scotland, & Wales) and ensure they
                    obtain and retain a receipt as proof of purchase;
                  </li>
                  <li>
                    scan the QR code found on Costa promotional point-of-sale
                    materials on or around the machine or in the store
                    advertising this promotion with a mobile phone or tablet
                    device with an enabled camera, or visit{" "}
                    <a href="http://www.costaexpressdailywin.co.uk">
                      www.costaexpressdailywin.co.uk
                    </a>
                    ; and
                  </li>
                  <li>
                    complete and submit the online entry form which appears on
                    screen (“Entry Form”) in full, ensuring they enter their
                    full name and email address to register and upload a
                    photograph of their receipt or other valid ‘proof of
                    purchase’ (see clause 2.2 below for details). Take care when
                    entering details; the Promoter is not responsible for
                    mistypes.
                  </li>
                </ol>
              </li>
              <li>
                For the purposes of this promotion, proof of purchase of a Costa
                Express drink during the Promotional Period is, in addition to
                the items in clause 2.1 above, required to submit a valid entry.
                The preferable form of proof of purchase is a till receipt from
                the retailer which includes a Costa Express purchase and is
                dated within the Promotional Period. Should this not be
                available, the Promoter may accept the following as an
                alternative proof of purchase:
                <ol>
                  <li>A machine receipt from a Costa Express machine.</li>
                  <li>
                    A screenshot of the Costa Club loyalty app transaction that
                    confirms a drink purchase and bean receipt within the
                    Promotional Period from a Costa Express machine.
                  </li>
                </ol>
                For the avoidance of doubt, the Promoter cannot accept bank
                statements as proof of purchase, as this will only detail a
                payment to the selected retailer and not a Costa Express drink.
              </li>
              <li>Internet access required.</li>
              <li>
                Only one (1) entry per person, per calendar day, throughout the
                Promotional Period. For the avoidance of doubt, only one unique
                email address will be accepted and that can only be used by one
                person. Any entrant(s) using multiple names, email addresses
                and/or sharing information (e.g. receipts) to enter the
                promotion will be disqualified.
              </li>
              <li>
                Only valid entry information will be accepted, and the Promoter
                reserves the right to disqualify and reject any inappropriate or
                invalid entries. All entry information is subject to
                verification and interrogation. Entry information may not be
                sold, shared, or exchanged. No incomplete, illegible, invalid,
                misdirected, corrupted entries or multiple entries from the same
                person beyond the daily play and entry limit will be accepted.
                The entry must be made directly by the person entering the
                promotion. Proof of sending will not be accepted as proof of
                delivery.
              </li>
              <li>
                In the event of suspicious activity, the Promoter reserves the
                right to request an explanation of purchase habits, gather
                information or obtain further evidence to confirm the legitimacy
                of the entry/win. Entries (bulk or otherwise) made from trade,
                syndicates, consumer groups or third parties will not be
                accepted. If it becomes apparent that an entrant is reposting or
                reusing the same content multiple times or using a computer(s)
                to circumvent this or any other condition by, for example, the
                use of ‘script’, ‘brute force’ or any other automated means,
                that person’s entries will be disqualified and any prize award
                will be void.
              </li>
            </ol>
          </li>
          <li>
            <h2>TECHNICAL REQUIREMENTS</h2>
            <ol>
              <li>
                Entrants must have a mobile phone or tablet device with an
                enabled camera to enter by scanning the QR code. This is also
                required so they can take a photograph of their receipt and
                upload it as proof of purchase or other valid 'proof of
                purchase' (see clause 2.2 above for details).
              </li>
              <li>
                Entrants must have access to an internet connection. Ask the
                bill payer before accessing an internet connection.
              </li>
              <li>
                Take care when entering details; the Promoter is not responsible
                for mistypes.
              </li>
              <li>
                If you are unable to access the website, please check with your
                network operator first.
              </li>
              <li>
                The Promoter does not accept responsibility for entries or
                claims that are delayed or not received due to transmission,
                network connection or software problems or any other reason
                beyond the Promoter’s control.
              </li>
            </ol>
          </li>
          <li>
            <h2>PRIZES</h2>
            <ol>
              <li>
                Online Daily Prizes
                <ol>
                  <li>
                    There are 387 Online Daily Prizes, in total, available to be
                    won throughout the Promotional Period.
                  </li>
                  <li>
                    At least one of the following prize types will be available
                    to be won every day of the Promotional Period:
                    <ol id="prize-list" start={"a"}>
                      <li>
                        £5 Costa Coffee e-gift card (86 in total available to be
                        won during the Promotional Period).
                      </li>
                      <li>
                        £10 Costa Coffee e-gift card (86 in total available to
                        be won during the Promotional Period).
                      </li>
                      <li>
                        £15 Costa Coffee e-gift card (43 in total available to
                        be won during the Promotional Period).
                      </li>
                      <li>
                        £20 Amazon e-gift card (43 in total available to be won
                        during the Promotional Period).
                      </li>
                      <li>
                        £10 Love2Shop e-gift card (43 in total available to be
                        won during the Promotional Period).
                      </li>
                      <li>
                        £40 Shell V-Power Voucher (2 x £20 vouchers printed) (43
                        in total available to be won during the Promotional
                        Period).
                      </li>
                      <li>
                        £20 Odeon e-gift card (43 in total available to be won
                        during the Promotional Period).
                      </li>
                    </ol>
                    Further details of the above prizes can be found in clause
                    5.1 below.
                  </li>
                </ol>
              </li>
              <li>
                Top Tier Prize Draw Prizes. All entrants who validly enter this
                promotion will automatically be entered into the Top Tier Prize
                Draw for an opportunity to win one of two top tier prizes. The
                Top Tier Prizes are: 1 x holiday prize; and 1 x £2,000 cash
                prize. Further details can be found in clause 5.2 below.
              </li>
              <li>
                Mop Up Prize Draw Prizes. Any Online Daily Prizes (i.e. those
                set out in clause 4.1 above) that have not been won or claimed
                during the Promotional Period will be reallocated to the Mop Up
                Prize Draw prize pool.
              </li>
              <li>
                Runner Up Prize Draw Prizes: All entrants who validly enter this
                promotion will automatically be entered into the Runner Up Prize
                Draw for an opportunity to win one of six Costa Coffee Hampers
                containing Costa Coffee products and other items. Further
                details can be found in clause 5.3 below.
              </li>
              <li>
                All prizes are strictly non-transferable. Any person found in
                breach of this term will be disqualified from participating in
                the promotion and/or claiming any prize won. No cash
                alternatives or other alternative prize will be available in
                whole or in part, except in the event of circumstances outside
                the reasonable control of the Promoter, whereby the Promoter
                reserves the right to substitute the prizes, or part of a prize,
                with prizes of equal or greater value. A prize will only be
                awarded directly to the winner at the address provided by the
                winner.
              </li>
              <li>
                In summary, there are 395 prizes available to be won in total
                via this promotion: 387 Online Daily Prizes; 6 Runner Up Prize
                Draw Prizes; and 2 Top Tier Prize Draw Prizes. Please see clause
                6 for details of how winners will be selected.
              </li>
            </ol>
          </li>

          <li>
            <h2>PRIZE TERMS</h2>
            <ol>
              <li>
                Online Daily Prizes
                <h3>£5 Costa Coffee e-gift card (i.e. digital gift card)</h3>
                <p>
                  Winners will be given one £5 Costa Coffee e-gift card which
                  can be used to purchase eligible items at participating Costa
                  Coffee shop outlets in the UK (excluding Northern Ireland).
                  Non-participating stores can be found{" "}
                  <a href="http://test97.reubeninternet.com/uploaded_files/1101/gifting-nonparticipatingstores.pdf">
                    here
                  </a>
                  . Costa Coffee e-gift cards cannot be redeemed at Costa
                  Express machines or in a Proud to Serve outlet. When a winner
                  uses their Costa Coffee e-gift card, the amount of their
                  purchase will be deducted from the balance on the card. The
                  remaining balance may be applied to future purchases. Change
                  will not be given. If a winner’s purchase exceeds the balance
                  on the Costa Coffee e-gift card, the winner must pay the
                  excess by another payment method. Costa Coffee e-gift cards
                  will be issued to winners as digital/electronic cards (a
                  physical card will not be provided), carrying codes which can
                  be redeemed in store and are subject to the terms and
                  conditions at{" "}
                  <a href="https://gifting.costa.co.uk/terms-and-conditions/">
                    https://gifting.costa.co.uk/terms-and-conditions/
                  </a>
                  . Please note that they can only be used for your personal
                  non-commercial use. You may not sell your Costa Coffee e-gift
                  card or use it in sales or promotional activities. Costa
                  Coffee e-gift cards will be valid for 12 months from the date
                  of issue. Redemption instructions will be provided along with
                  the e-gift card, which will be sent to winners by email. Full
                  T&Cs can be found at:{" "}
                  <a href="https://gifting.costa.co.uk/terms-and-conditions/">
                    https://gifting.costa.co.uk/terms-and-conditions/
                  </a>
                  .
                </p>
                <h3>£10 Costa Coffee e-gift card (i.e. digital gift card)</h3>
                <p>
                  Winners will be given one £10 Costa Coffee e-gift card which
                  can be used to purchase eligible items at participating Costa
                  Coffee shop outlets in the UK (excluding Northern Ireland).
                  Non-participating stores can be found{" "}
                  <a href="http://test97.reubeninternet.com/uploaded_files/1101/gifting-nonparticipatingstores.pdf">
                    here
                  </a>
                  . Costa Coffee e-gift cards cannot be redeemed at Costa
                  Express machines or in a Proud to Serve outlet. When a winner
                  uses their Costa Coffee e-gift card, the amount of their
                  purchase will be deducted from the balance on the card. The
                  remaining balance may be applied to future purchases. Change
                  will not be given. If a winner’s purchase exceeds the balance
                  on the Costa Coffee e-gift card, the winner must pay the
                  excess by another payment method. Costa Coffee e-gift cards
                  will be issued to winners as digital/electronic cards (a
                  physical card will not be provided), carrying codes which can
                  be redeemed in store and are subject to the terms and
                  conditions at{" "}
                  <a href="https://gifting.costa.co.uk/terms-and-conditions/">
                    https://gifting.costa.co.uk/terms-and-conditions/
                  </a>
                  . Please note that they can only be used for your personal
                  non-commercial use. You may not sell your Costa Coffee e-gift
                  card or use it in sales or promotional activities. Costa
                  Coffee e-gift cards will be valid for 12 months from the date
                  of issue. Redemption instructions will be provided along with
                  the e-gift card, which will be sent to winners by email. Full
                  T&Cs can be found at:{" "}
                  <a href="https://gifting.costa.co.uk/terms-and-conditions/">
                    https://gifting.costa.co.uk/terms-and-conditions/
                  </a>
                  .
                </p>
                <h3>£15 Costa Coffee e-gift card (i.e. digital gift card)</h3>
                <p>
                  Winners will be given one £15 Costa Coffee e-gift card which
                  can be used to purchase eligible items at participating Costa
                  Coffee shop outlets in the UK (excluding Northern Ireland).
                  Non-participating stores can be found{" "}
                  <a href="http://test97.reubeninternet.com/uploaded_files/1101/gifting-nonparticipatingstores.pdf">
                    here
                  </a>
                  . Costa Coffee e-gift cards cannot be redeemed at Costa
                  Express machines or in a Proud to Serve outlet. When a winner
                  uses their Costa Coffee e-gift card, the amount of their
                  purchase will be deducted from the balance on the card. The
                  remaining balance may be applied to future purchases. Change
                  will not be given. If a winner’s purchase exceeds the balance
                  on the Costa Coffee e-gift card, the winner must pay the
                  excess by another payment method. Costa Coffee e-gift cards
                  will be issued to winners as digital/electronic cards (a
                  physical card will not be provided), carrying codes which can
                  be redeemed in store and are subject to the terms and
                  conditions at{" "}
                  <a href="https://gifting.costa.co.uk/terms-and-conditions/">
                    https://gifting.costa.co.uk/terms-and-conditions/
                  </a>
                  . Please note that they can only be used for your personal
                  non-commercial use. You may not sell your Costa Coffee e-gift
                  card or use it in sales or promotional activities. Costa
                  Coffee e-gift cards will be valid for 12 months from the date
                  of issue. Redemption instructions will be provided along with
                  the e-gift card, which will be sent to winners by email. Full
                  T&Cs can be found at:{" "}
                  <a href="https://gifting.costa.co.uk/terms-and-conditions/">
                    https://gifting.costa.co.uk/terms-and-conditions/
                  </a>
                  .
                </p>
                <h3>£20 Amazon e-gift card (i.e. digital gift card)</h3>
                <p>
                  Winners will be given one £20 e-gift card to be redeemed at
                  Amazon.co.uk, which offers a range of products online. The
                  prize will be delivered to winners as an e-gift card (a
                  physical card will not be provided), carrying codes which can
                  be redeemed online. If a purchase exceeds the redeemer's
                  e-gift card balance, the remaining amount must be paid with
                  another payment method accepted on Amazon.co.uk. Each e-gift
                  card will be valid for 10 years from the date of issue.
                  Amazon.co.uk e-gift cards cannot be used to purchase other
                  gift cards, cannot be reloaded, resold, transferred for value,
                  used for unauthorised commercial purposes, including to
                  facilitate the resale or shipment of goods from Amazon.co.uk,
                  redeemed for cash, or used in a manner otherwise prohibited by
                  the Amazon.co.uk Gift Cards Restrictions and Prohibited
                  Activities policy. Unused e-gift card balances in an
                  Amazon.co.uk account may not be transferred to another
                  Amazon.co.uk account. Redemption instructions will be provided
                  along with the e-gift card, which will be sent to winners by
                  e-mail. Full T&Cs can be found at:{" "}
                  <a href="https://www.amazon.co.uk/gp/help/customer/display.html%3FnodeId=200272910&app-nav-type=modal/ref=gcui_d_e_tc_o_d">
                    https://www.amazon.co.uk/gp/help/customer/display.html%3FnodeId=200272910&app-nav-type=modal/ref=gcui_d_e_tc_o_d
                  </a>
                  .
                </p>
                <h3>£10 Love2Shop e-gift card (i.e. digital gift card)</h3>
                <p>
                  Winners will be given one £10 Love2Shop e-gift card which can
                  be used to purchase goods online at{" "}
                  <a href="http://www.love2shopdigital.co.uk">
                    www.love2shopdigital.co.uk
                  </a>
                  . Winners can choose to exchange their Love2shop e-gift card
                  to unlock a selection of e-gift cards from high street and
                  online brands. Each retailer's e-gift card is subject to its
                  own terms, conditions and exclusions. Unused balances are not
                  transferable. The prize will be delivered to winners as an
                  e-gift card (a physical card will not be provided). E-gift
                  cards from Love2Shop cannot be exchanged for cash and can only
                  be used to purchase goods online at
                  www.love2shopdigital.co.uk. They cannot be redeemed instore or
                  be sold. Love2shop e-gift cards will expire on the date set
                  out in the email notifying the winner of the Love2shop e-gift
                  card number following which it will no longer be valid.
                  Redemption instructions will be provided along with the e-gift
                  card, which will be sent to winners by e-mail. Full T&Cs can
                  be found at:{" "}
                  <a href="https://www.highstreetvouchers.com/COMMON/corporate/terms/Love2shop-e-Gift-Cards-End-User-TCs.pdf">
                    Love2shop-e-Gift-Cards-End-User-TCs.pdf
                  </a>
                  .
                </p>
                <h3>£40 Shell V-Power Voucher (2 x £20 vouchers printed)</h3>
                <p>
                  Winners will be given two £20 printed Shell V-Power Vouchers
                  (total of £40) by post (please see clauses 6.1.8 and 6.1.9 for
                  details of how the prize will be provided, when it will be
                  provided and the information required from winners). Shell
                  V-Power Vouchers are redeemable only for Shell V-Power fuel at
                  participating Shell Service Stations in the UK only. Shell
                  V-Power Vouchers are the property of Shell U.K. Oil Products
                  Limited (as an agent of Shell U.K. Limited) and are not for
                  resale or publication. Vouchers can only be redeemed once and
                  by the person to whom they are issued to. Vouchers can be
                  exchanged for their face value, or a higher value payment of
                  the difference. The maximum value of vouchers redeemable in a
                  single transaction is £50. No change or credit will be given
                  if the purchase is less than the value stated on the Voucher.
                  Persons must be aged 16 years or over to use these Vouchers.
                  The Vouchers are valid from 16<sup>th</sup> June 2024 – 16
                  <sup>th</sup> June 2026. The cash redemption value of each
                  voucher is 0.01p. Redemption instructions will be provided
                  along with the Vouchers, which will be sent to winners by
                  post. All T&Cs will also be printed on each Voucher.
                </p>
                <h3>£20 Odeon e-gift card (i.e. digital gift card)</h3>
                <p>
                  Winners will be given one £20 Odeon e-gift card (a physical
                  card will not be provided). Odeon e-gift cards can be used at
                  participating ODEON branded cinemas in the UK. They can be
                  used in cinema, on the ODEON website (www.odeon.co.uk) and on
                  the myODEON app to pay for tickets (including any applicable
                  online booking fees), food, drink, and gaming sessions. All
                  purchases using this card are subject to availability, normal
                  age restrictions, and any other applicable terms. Odeon e-gift
                  cards cannot be re-loaded or topped up with value. The value
                  on the e-gift card may be used where the transaction total is
                  higher than the card balance, upon payment of the difference.
                  If all the value on the e-gift card is not used in a
                  transaction, the remaining balance will be left on the card.
                  No change will be given. If an Odeon e-gift card is not used
                  for a period of 2 years, any remaining balance will expire. A
                  balance enquiry does not constitute use. An Odeon e-gift card
                  is for personal non-commercial use only and cannot be resold.
                  Redemption instructions will be provided along with the e-gift
                  card, which will be sent to winners by e-mail. Full T&Cs can
                  be found at:{" "}
                  <a href="https://www.odeon.co.uk/offers-and-competitions/odeon-gift-card/">
                    https://www.odeon.co.uk/offers-and-competitions/odeon-gift-card/
                  </a>
                  .
                </p>
              </li>
              <li>
                Top Tier Prize Draw Prizes
                <h3>Holiday Prize</h3>
                <ol>
                  <li>
                    There is one holiday prize in total to be won (please see
                    clause 6.2 for details of how this prize will be drawn and
                    allocated). This prize is for a holiday to Barcelona, Spain
                    for two adults (i.e. the winner and one guest). The winner
                    and their guest must be 18 years of age or older. This prize
                    includes:
                    <ul>
                      <li>
                        Return economy class flights for two people to Barcelona
                        Airport–El Prat (BCN) with ‘hold’ luggage included from
                        the nearest airport in Great Britain to the winner. We
                        will make every effort to fly winners out from their
                        nearest airport in Great Britain. The airline used for
                        the flights will be selected at the time of booking
                        based on availability.
                      </li>
                      <li>
                        Return private transfers from Barcelona Airport–El Prat
                        (BCN) to the hotel.
                      </li>
                      <li>
                        Five nights' accommodation for two people at a 4 star
                        hotel called{" "}
                        <a href="https://www.nh-hotels.com/en/hotel/nh-collection-barcelona-constanza?campid=8435708&utm_campaign=nh_hotel&utm_source=google&utm_medium=cpc&utm_id=16575947922&utm_source_platform=sa360&gad_source=1&gclid=Cj0KCQjws-S-BhD2ARIsALssG0ZHV121Kj8dwnGwonHKU24XPfSyUV5REJxzVB6eFkWzJIMAxZyhd4waAo9OEALw_wcB&gclsrc=aw.ds">
                          Hotel NH Collection Barcelona Constanza, more
                          information on the selected hotel can be found at
                          nh-hotels.com
                        </a>
                        . The selected hotel is subject to availability at the
                        time of booking. If unavailable, a similarly located and
                        quality hotel will be provided.
                      </li>
                      <li>
                        Accommodation is based on two people sharing a
                        double/twin room on a bed and breakfast basis.
                      </li>
                      <li>
                        £250 spending money. This is a total amount, not a per
                        person figure.
                      </li>
                    </ul>
                  </li>
                  <li>
                    There will be one winner of the holiday prize, who will be
                    selected in the Top Tier Prize Draw at the end of the
                    Promotional Period. The same person cannot win the holiday
                    prize and cash prize. Please see clause 6.2 for further
                    details.
                  </li>
                  <li>
                    The holiday prize must be booked within 12 months of being
                    provided to the winner and must be taken before 15 May 2026.
                    The holiday prize cannot be taken during UK bank holidays,
                    Christmas Day, Christmas Eve, Good Friday, Easter Sunday,
                    Easter Monday, New Year's Eve or New Year's Day, or during
                    school holidays in England, Scotland, and Wales, as the
                    costs will rise during those times.
                  </li>
                  <li>
                    The £250 spending money will be provided to the winner via a
                    prepaid MasterCard in their name, sent to a provided postal
                    address via Tracked Royal Mail post. The Promoter is not
                    liable or required to replace this element of the holiday
                    prize if it is not successfully posted, received, or able to
                    be used due to incorrect details being provided by the
                    winner. This prepaid MasterCard can be used anywhere
                    MasterCard is accepted and is valid for 12 months, after
                    which it will expire. This card is issued by Transact
                    Payments Limited pursuant to licenses by MasterCard
                    International. Transact Payments Limited is authorised and
                    regulated by the Gibraltar Financial Services Commission.
                    The winner’s use of the prepaid card is governed by the
                    Cardholder Agreement, and some fees may apply. This is not a
                    gift card. Please note that prepaid cards are subject to
                    expiration, so the winner must pay close attention to the
                    expiration date of the card.
                  </li>
                  <li>
                    Neither this prize, nor any part of it, is valid in
                    conjunction with any other offers or promotions, and it is
                    not refundable, transferable, or exchangeable for cash or
                    any other services. No substitution will be made except as
                    provided herein at the Promoter’s sole discretion.
                  </li>
                  <li>
                    The Promoter reserves the right to substitute the prize for
                    one of equal or greater value if the designated prize should
                    become unavailable for any reason or in the event of
                    circumstances outside the reasonable control of the
                    Promoter.
                  </li>
                  <li>
                    All holiday prize locations, bookings, travel (including
                    flights), events, activities, hotels and any other goods and
                    services are subject to availability at the time of booking.
                  </li>
                  <li>
                    Any applicable additional charges outside of the prize
                    package detailed above requested by the winner, must be paid
                    for by the winner at the time of booking for all the
                    travelling party.
                  </li>
                  <li>
                    The holiday prize duration cannot be extended unless agreed
                    upon booking and additional costs payable by the winner are
                    agreed. Any additional passengers booked will be charged at
                    normal rates for additional flights and rooms. Please note,
                    once a winner has made a booking, they cannot amend the
                    travel dates.
                  </li>
                  <li>
                    The holiday prize does not include travel between the
                    winner’s home and chosen airport, personal expenditure or
                    incidental costs, expenses, travel or other costs not
                    expressly stated in the prize description above. These are
                    the sole responsibility of the winner and their guest. The
                    prize does not include petrol or parking. It is the
                    responsibility of the prize-winner and guest to ensure that
                    they have a valid passport, health insurance and travel
                    insurance and obtain any necessary vaccinations and visas
                    for their trip. Visa must be submitted 6 weeks ahead of
                    departure and any failure to do so, or if the visa is being
                    refused, no compensation can be given.
                  </li>
                  <li>
                    The Promoter and partner agents of the Promoter will not be
                    liable for any cancellations, or if flights or any other
                    element of the prize are delayed, postponed, or cancelled
                    for any reason.
                  </li>
                  <li>
                    The winner understands and agrees that the Promoter has the
                    right, in its sole discretion, to disqualify and remove a
                    winner or his/her guest(s) from any activity or element of
                    the prize at any time if the winner’s or his/her guest’s
                    behaviour at any point is uncooperative, disruptive, or may
                    or does cause damage to person, property, or the reputation
                    of Promoter, and in such a case, the winner will still be
                    solely responsible for all taxes and other expenses related
                    to the prize.
                  </li>
                  <li>
                    The Promoter will not be held responsible for any goods or
                    services provided outside of the allocated winning prize.
                  </li>
                </ol>
                <h3>Cash prize</h3>
                <ol start="13">
                  <li>
                    There is one ‘cash’ prize in total to be won (please see
                    clause 6.2 for details of how this prize will be drawn and
                    allocated). This prize is one prepaid MasterCard with a
                    value of £2,000.
                  </li>
                  <li>
                    There will be one winner of the prepaid MasterCard with a
                    value of £2,000, who will be selected in the Top Tier Prize
                    Draw at the end of the Promotional Period. The same person
                    cannot win the holiday prize and the prepaid MasterCard.
                    Please see clause 6.2 for further details.
                  </li>
                  <li>
                    The winner of this prize will be contacted to verify their
                    details and confirm fulfilment. The winner will be sent one
                    prepaid MasterCard with a value of £2,000 in their name to a
                    provided postal address via Tracked Royal Mail post. This
                    prepaid MasterCard can be used anywhere MasterCard is
                    accepted and is valid for 12 months, after which it will
                    expire. This card is issued by Transact Payments Limited
                    pursuant to licenses by MasterCard International. Transact
                    Payments Limited is authorised and regulated by the
                    Gibraltar Financial Services Commission. The winner’s use of
                    the prepaid card is governed by the Cardholder Agreement,
                    and some fees may apply. This is not a gift card. Please
                    note that prepaid cards are subject to expiration, so the
                    winner must pay close attention to the expiration date of
                    the card.
                  </li>
                  <li>
                    This prize is not valid in conjunction with any other offers
                    or promotions and is not refundable, transferrable nor
                    exchangeable in cash or for any other services. No
                    substitution will be made except as provided herein at the
                    Promoter’s sole discretion.
                  </li>
                  <li>
                    The Promoter reserves the right to substitute the prize for
                    one of equal or greater value if the designated prize should
                    become unavailable for any reason or in the event of
                    circumstances outside the reasonable control of the
                    Promoter.
                  </li>
                  <li>
                    The Promoter is not liable or required to replace the prize
                    if the prize is not successfully posted, received, or able
                    to be used due to incorrect details being provided by the
                    winner.
                  </li>
                  <li>
                    The Promoter will not be held responsible for any goods or
                    services provided outside of the allocated winning prize.
                  </li>
                </ol>
              </li>
              <li>
                Runner Up Prize Draw Prizes
                <ol>
                  <li>
                    There are six Runner Up Prize Draw prizes in total to be won
                    (please see clause 6.4 for details of how this prize will be
                    drawn and allocated), one Runner Up Prize Draw prize per
                    Runner Up Prize Draw winner. Runner Up Prize Draw winners
                    will be selected in the Runner Up Prize Draw at the end of
                    the Promotional Period.
                  </li>
                  <li>
                    Each Runner Up Prize Draw winner will be given one Costa
                    Coffee hamper by post (please see clause 6.4.6 for details
                    of how the prize will be provided, when it will be provided
                    and the information required from winners). Each Costa
                    Coffee hamper includes: a wicker basket; the following
                    ‘Ready to Drink’ Costa Coffee products - one Latte (250ml),
                    one Frappe (250ml) and one Latte (330ml); one Barista
                    Creations Creamy Cappuccino Instant Coffee (255g); two
                    coffee mugs (not Costa Coffee branded); one small box of
                    chocolates; one packet of luxury biscuits; and one £5 Costa
                    Coffee physical gift card (this is not a digital e-gift
                    card). Please see clause 5.1 above for details of Costa
                    Coffee e-gift cards, including exclusions and key terms that
                    also apply to the use of this physical gift card.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <h2>WINNERS</h2>
            <ol>
              <li>
                Online Daily Prize Winners
                <ol>
                  <li>
                    During the promotion, Online Daily Prizes will be randomly
                    allocated and linked to open ‘winning moments’ that have
                    been pre-selected by a secure, independently verified
                    computer program. There are 387 winning moments available,
                    in total, throughout the Promotional Period for Online Daily
                    Prizes.
                  </li>
                  <li>
                    The winning moments for Online Daily Prizes will occur
                    throughout the Promotional Period. There will be at least
                    one winning moment per day during the Promotional Period
                    which has one of the following Online Daily Prizes allocated
                    to it: £5 Costa Coffee e-gift card; £10 Costa Coffee e-gift
                    card; £15 Costa Coffee e-gift card; £20 Amazon e-gift card;
                    £10 Love2Shop e-gift card; £40 Shell V-Power Voucher; and
                    £20 Odeon e-gift card. The first person to enter at the same
                    time as any allocated winning moment will be deemed to have
                    won the Online Daily Prize randomly allocated to that
                    winning moment. If nobody enters at that time, winning
                    moments will roll over into the next second, and so on,
                    until someone enters the promotion. The first person to
                    enter after that point and before the end of that day will
                    be allocated that win. Winning moments and any Online Daily
                    Prizes that are not allocated to the winning moment during a
                    day within the Promotional Period will roll over to the next
                    day, and so on, until the end of the Promotional Period.
                  </li>
                  <li>
                    All 387 Online Daily Prizes are available to be won but are
                    not guaranteed to be won during the Promotional Period. If
                    any Online Daily Prizes are not won or claimed during the
                    Promotional Period, they will be allocated to the Mop Up
                    Prize Draw prize pool to be won during the Mop Up Prize
                    Draw.
                  </li>
                  <li>
                    All Online Daily Prize winners will be subject to a
                    verification process, which includes checking their
                    receipt/proof of purchase the day after they have entered,
                    to ensure the prize can be validly awarded and that they
                    have met the entry criteria for this promotion.
                  </li>
                  <li>
                    If the verification process described in clause 6.1.4 is
                    successful, Online Daily Prize winners will be notified by
                    email, using the email address provided when they registered
                    (i.e. in their Entry Form), that they have won on the day
                    after they entered this promotion. This email will include
                    details of the prize they have won and instructions on how
                    to claim and redeem it. Entrants are encouraged to monitor
                    this email account during this time in case they are a
                    winner. Valid entrants who have not won an Online Daily
                    Prize will not receive an email. It is the responsibility of
                    entrants to check junk/spam folders to ensure they are in
                    receipt of any communications to them.
                  </li>
                  <li>
                    If a winner of an Online Daily Prize is deemed invalid or
                    the verification process described in clause 6.1.4 is not
                    successful, for example, because they have not met the entry
                    criteria for this promotion (e.g. by providing valid proof
                    of purchase), their prize will be forfeited and placed into
                    the Mop Up Prize Draw pool. Their entry will also be removed
                    from the Top Tier Prize Draw, Runner Up Prize Draw, and Mop
                    Up Prize Draw unless the date of those draws has already
                    passed. If the date of the Mop Up Prize Draw has passed, the
                    prize will be withdrawn from this promotion.
                  </li>
                  <li>
                    All valid entrants to this promotion will be automatically
                    entered into the Top Tier Prize Draw, Runner Up Prize Draw,
                    and Mop Up Prize Draw.
                  </li>
                  <li>
                    To enable prize fulfilment, winners of the Online Daily
                    Prize of Shell V-Power Vouchers must provide their
                    postal/delivery address within 28 days of notification that
                    they have won. Shell V-Power Vouchers will be posted to
                    winners at the address provided within 28 days of receiving
                    the address details, via Tracked Royal Mail post. Inaccurate
                    information may result in the prize being forfeited. Winners
                    should retain their notification email message until their
                    prize has been received.
                  </li>
                  <li>
                    If a winner of a Shell V-Power Voucher does not claim the
                    prize within 28 days of being notified that they have won,
                    the required address information to enable prize delivery
                    hasn’t been provided, they reject their prize, or are
                    otherwise in breach of these Terms and Conditions, or unable
                    to take up this prize for any other reason, then the prize
                    will be forfeited and withdrawn from this promotion or, if
                    possible, allocated to the Mop Up Prize Draw pool if the
                    date for that Mop Up Prize Draw has not passed.
                  </li>
                  <li>
                    The Promoter accepts no responsibility for failed delivery
                    of Online Daily Prizes due to the provision of incorrect
                    contact details.
                  </li>
                </ol>
              </li>
              <li>
                Top Tier Prize Draw Winners
                <ol>
                  <li>
                    Entrants that have validly entered this promotion during the
                    Promotional Period will automatically be entered into the
                    Top Tier Prize Draw.
                  </li>
                  <li>
                    All valid entrants will receive confirmation of entry into
                    the Top Tier Prize Draw, subject to verification, via an
                    onscreen message after they have submitted their Entry Form.
                  </li>
                  <li>
                    The Top Tier Prize Draw will take place via an independently
                    audited and verified random prize draw selection process on
                    21 May 2025. There will be one winner of the holiday prize
                    and one winner of the cash prize. The same person cannot win
                    both the holiday prize and the cash prize. Two reserves will
                    be selected for the holiday prize, and two different
                    reserves will be selected for the cash prize.
                  </li>
                  <li>
                    The Top Tier Prize Draw winners will be subject to a
                    verification process, which includes checking their
                    receipt/proof of purchase, to ensure the prize can be
                    validly awarded and that they have met the entry criteria
                    for this promotion.
                  </li>
                  <li>
                    If the verification process described in clause 6.2.4 is
                    successful, the Top Tier Prize winners will be notified by
                    email, using the email address provided when they registered
                    (i.e. in their Entry Form), within 3 business days of the
                    Top Tier Prize Draw taking place, that they have won. This
                    email will include details of the prize they have won and
                    instructions on how to claim and redeem it. Entrants are
                    encouraged to monitor this email account during this time in
                    case they are a winner. Valid entrants who have not won a
                    Top Tier Prize Draw prize will not receive an email. It is
                    the responsibility of entrants to check junk/spam folders to
                    ensure they are in receipt of any communications to them.
                  </li>
                  <li>
                    If a winner of a Top Tier Prize Draw prize is deemed invalid
                    or the verification process described in clause 6.2.4 is not
                    successful, for example, because they have not met the entry
                    criteria for this promotion (e.g. by providing valid proof
                    of purchase), their prize will be forfeited and awarded to
                    the reserve drawn next in line for that prize. If that
                    reserve is also deemed invalid or the verification process
                    described in clause 6.2.4 is not successful, their prize
                    will be forfeited and awarded to the reserve drawn next in
                    line for that prize. If the original winner and all reserves
                    for that prize are invalid winners, or if the verification
                    process described in clause 6.2.4 is not successful, then
                    the prize will be forfeited and withdrawn from this
                    promotion.
                  </li>
                  <li>
                    To enable prize fulfilment, the winners of the Top Tier
                    Prize Draw prizes must provide their contact telephone
                    number, proof of age, and proof of address, together with
                    any other reasonably requested information required to
                    enable prize fulfilment within 28 days of notification that
                    they have won. For example, the holiday prize winner must
                    provide information required to book their holiday, such as
                    passport details for travel purposes for themselves and
                    their guest, and their postal/delivery address to enable the
                    £250 spending money, provided via a prepaid MasterCard in
                    their name, to be sent to them. The cash prize winner must
                    also provide their postal/delivery address to enable the
                    £2,000 prepaid MasterCard to be sent to them.
                  </li>
                  <li>
                    The holiday prize must be booked within 12 months of it
                    being provided to the winner and must be taken before 15 May
                    2026. The prepaid MasterCard with a value of £250, to be
                    used as spending money, will be posted to the winner via
                    Tracked Royal Mail post to the postal/delivery address
                    provided 28 days before the holiday booking commences.
                  </li>
                  <li>
                    The cash prize (i.e. prepaid MasterCard with a value of
                    £2,000) will be posted to the winner using the postal
                    address provided via Tracked Royal Mail post 28 days after
                    they have provided the required information set out in
                    clause 6.2.7.
                  </li>
                  <li>
                    Inaccurate information may result in a Top Tier Prize Draw
                    prize being forfeited (in whole or in part). Winners should
                    retain their notification email message until their prize
                    has been received.
                  </li>
                  <li>
                    If a winner of a Top Tier Prize Draw prize does not claim
                    the prize within 28 days of being notified that they have
                    won, the required information to enable prize delivery
                    hasn’t been provided, they reject their prize, or are
                    otherwise in breach of these Terms and Conditions, or unable
                    to take up this prize for any other reason (the “Forfeiture
                    Conditions”), then their prize will be forfeited and awarded
                    to the reserve drawn next in line for that prize. If that
                    reserve meets any of the Forfeiture Conditions, their prize
                    will be forfeited and awarded to the reserve drawn next in
                    line for that prize. If the original winner and all reserves
                    for that prize meet the Forfeiture Conditions, then the
                    prize will be forfeited and withdrawn from this promotion.
                  </li>
                  <li>
                    The Promoter accepts no responsibility for failed delivery
                    of Top Tier Prize Draw prizes due to the provision of
                    incorrect details.
                  </li>
                </ol>
              </li>
              <li>
                Mop Up Prize Draw Winners
                <ol>
                  <li>
                    Entrants that have validly entered this promotion during the
                    Promotional Period will automatically be entered into the
                    Mop Up Prize Draw.
                  </li>
                  <li>
                    The Mop Up Prize Draw prizes will include:
                    <ol>
                      <li>
                        Online Daily Prizes that were won but have been entered
                        into the Mop Up Prize Draw pool due to the winner being
                        ineligible or invalid (e.g. due to a failure to provide
                        valid proof of purchase).
                      </li>
                      <li>
                        Online Daily Prizes not won within the Promotional
                        Period, so the winning moments have rolled over until
                        the end of the Promotional Period.
                      </li>
                      <li>
                        Online Daily Prizes that have not been claimed, or that
                        have been forfeited or rejected before the date of the
                        Mop Up Prize Draw.
                      </li>
                    </ol>
                  </li>
                  <li>
                    The Mop Up Prize Draw will take place via an independently
                    audited and verified random prize draw selection process on
                    21 May 2025.
                  </li>
                  <li>
                    The Mop Up Prize Draw winners will be subject to a
                    verification process, which includes checking their
                    receipt/proof of purchase, to ensure the prize can be
                    validly awarded and that they have met the entry criteria
                    for this promotion.
                  </li>
                  <li>
                    If the verification process described in clause 6.3.4 is
                    successful, the Mop Up Prize Draw winners will be notified
                    by email, using the email address provided when they
                    registered (i.e. in their Entry Form), within 3 business
                    days of the Mop Up Prize Draw taking place, that they have
                    won. This email will include details of the prize they have
                    won and instructions on how to claim and redeem it. Entrants
                    are encouraged to monitor this email account during this
                    time in case they are a winner. Valid entrants who have not
                    won a Mop Up Prize Draw prize will not receive an email. It
                    is the responsibility of entrants to check junk/spam folders
                    to ensure they are in receipt of any communications to them.
                  </li>
                  <li>
                    If a winner of a Mop Up Prize Draw prize is deemed invalid
                    or the verification process described in clause 6.3.4 is not
                    successful, for example, because they have not met the entry
                    criteria for this promotion (e.g. by providing valid proof
                    of purchase), their prize will be forfeited and withdrawn
                    from this promotion.
                  </li>
                  <li>
                    The provisions of clauses 6.1.8 and 6.1.9 will apply to the
                    fulfilment of any Shell V-Power Vouchers that are Mop Up
                    Prize Draw prizes.
                  </li>
                  <li>
                    The Promoter accepts no responsibility for failed delivery
                    of Mop Up Prize Draw prizes due to the provision of
                    incorrect contact details.
                  </li>
                </ol>
              </li>
              <li>
                Runner Up Prize Draw Winners
                <ol>
                  <li>
                    Entrants that have validly entered this promotion during the
                    Promotional Period will automatically be entered into the
                    Runner Up Prize Draw.
                  </li>
                  <li>
                    The Runner Up Prize Draw will take place via an
                    independently audited and verified random prize draw
                    selection process on 21 May 2025. There will be one winner
                    of each Runner Up Prize Draw Prize (see clause 5.3 for
                    details of the Runner Up Prize Draw prizes). Six reserves
                    will also be selected for the Runner Up Prize Draw prizes.
                  </li>
                  <li>
                    The Runner Up Prize Draw winners will be subject to a
                    verification process, which includes checking their
                    receipt/proof of purchase, to ensure the prize can be
                    validly awarded and that they have met the entry criteria
                    for this promotion.
                  </li>
                  <li>
                    If the verification process described in clause 6.4.3 is
                    successful, the Runner Up Prize Draw winners will be
                    notified by email, using the email address provided when
                    they registered (i.e. in their Entry Form), within 3
                    business days of the Runner Up Prize Draw taking place, that
                    they have won. This email will include details of the prize
                    they have won and instructions on how to claim and redeem
                    it. Entrants are encouraged to monitor this email account
                    during this time in case they are a winner. Valid entrants
                    who have not won a Runner Up Prize Draw prize will not
                    receive an email. It is the responsibility of entrants to
                    check junk/spam folders to ensure they are in receipt of any
                    communications to them.
                  </li>
                  <li>
                    If a winner of a Runner Up Prize Draw prize is deemed
                    invalid or the verification process described in clause
                    6.4.3 is not successful, for example, because they have not
                    met the entry criteria for this promotion (e.g. by providing
                    valid proof of purchase), their prize will be forfeited and
                    awarded to the reserve drawn next in line for that prize. If
                    that reserve is also deemed invalid or the verification
                    process described in clause 6.4.3 is not successful, their
                    prize will be forfeited and awarded to the reserve drawn
                    next in line for that prize, and so on. If the original
                    winner and all reserves for that prize are invalid winners,
                    or if the verification process described in clause 6.4.3 is
                    not successful, then the prize will be forfeited and
                    withdrawn from this promotion.
                  </li>
                  <li>
                    To enable prize fulfilment, winners of the Runner Up Prize
                    Draw prizes must provide their postal/delivery address
                    within 28 days of notification that they have won. Runner Up
                    Prize Draw prizes will be posted to winners at the address
                    provided within 28 days of receiving the address details,
                    via Tracked Royal Mail post. Inaccurate information may
                    result in the prize being forfeited. Winners should retain
                    their notification email message until their prize has been
                    received.
                  </li>
                  <li>
                    If a winner of a Runner Up Prize Draw prize does not claim
                    the prize within 28 days of being notified that they have
                    won, the required address information to enable prize
                    delivery hasn’t been provided, they reject their prize, or
                    are otherwise in breach of these Terms and Conditions, or
                    unable to take up this prize for any other reason (the
                    “Runner Up Forfeiture Conditions”), then their prize will be
                    forfeited and awarded to the reserve drawn next in line for
                    that prize. If that reserve meets any of the Runner Up
                    Forfeiture Conditions, their prize will be forfeited and
                    awarded to the reserve drawn next in line for that prize,
                    and so on. If the original winner and all reserves for that
                    prize meet the Runner Up Forfeiture Conditions, then the
                    prize will be forfeited and withdrawn from this promotion.
                  </li>
                  <li>
                    Inaccurate information may result in a Runner Up Prize Draw
                    prize being forfeited (in whole or in part). Winners should
                    retain their notification email message until their prize
                    has been received.
                  </li>
                  <li>
                    The Promoter accepts no responsibility for failed delivery
                    of Runner Up Prize Draw prizes due to the provision of
                    incorrect contact details.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <h2>LIABILITY</h2>
            <ol>
              <li>
                Subject to clause 7.2, if the Promoter fails to comply with
                these Terms and Conditions, the Promoter will be responsible for
                loss or damage entrants suffer or sustain (whether or not
                arising from any person’s negligence) that is a foreseeable
                result of the Promoter’s breach of these Terms and Conditions.
                The Promoter is not responsible for any loss or damage that is
                not foreseeable. Loss or damage is foreseeable if they were an
                obvious consequence of the Promoter's breach or if they were
                contemplated by you and the Promoter at the time that you
                entered the promotion.
              </li>
              <li>
                Nothing in these Terms and Conditions excludes or limits the
                Promoter’s liability for: (a) death or personal injury caused by
                the Promoter’s negligence; (b) fraud or fraudulent
                misrepresentation; or (c) any matter in respect of which it
                would be unlawful for the Promoter to exclude or restrict its
                liability.
              </li>
              <li>
                Limits of liability: insofar as permitted by law, neither the
                Promoter nor the promotional parties assume any responsibility
                or liability for:
                <ol type="a">
                  <li>
                    Any incorrect or inaccurate code entry, or for any faulty,
                    incorrect, errors or failed electronic data transmissions;
                  </li>
                  <li>
                    Any unauthorised access to, or theft, destruction or
                    alteration of codes at any point in the operation of this
                    promotion;
                  </li>
                  <li>
                    Communications line failure, regardless of cause, with
                    regard to any equipment, systems, networks, lines,
                    satellites, servers, computers or providers utilised in any
                    aspect of this promotion;
                  </li>
                  <li>
                    Inaccessibility or unavailability of the internet or the
                    website or any combination thereof;
                  </li>
                  <li>
                    Insofar as permitted by law, any injury or damage to
                    participants or to any other person’s computer which may be
                    related to or resulting from any attempt to participate in
                    the promotion.
                  </li>
                </ol>
              </li>
              <li>
                Except as otherwise required by applicable law, the Promoter
                accepts no responsibility for system errors or other issues that
                may result in disruption to, lost, delayed or not received
                entries, winner notifications, verification or prizes.
              </li>
              <li>
                In the event of circumstances outside the reasonable control of
                the Promoter, or otherwise where fraud, abuse, and/or an error
                (human or computer) affects or could affect the proper operation
                of this promotion or the awarding of prizes, and only where
                circumstances make this unavoidable, the Promoter reserves the
                right to cancel or amend the promotion or these Terms and
                Conditions, at any stage, but will always endeavour to minimize
                the effect to participants in order to avoid undue
                disappointment.
              </li>
              <li>
                All personal data submitted in connection with this promotion
                will be processed by the Promoter for the purposes of
                administering and managing the promotion and prizes (where
                applicable) and verifying the eligibility of each entrant. You
                acknowledge that the Promoter may pass such information to its
                third-party agency, Mesh Marketing Ltd, for the purposes of
                administering and managing the promotion and prizes and
                verifying the eligibility of each entrant. The Promoter is
                committed to protecting the privacy of all entrants. Data that
                is collected from or about entrants will be used in accordance
                with the Promoter’s Privacy Policy (which also includes
                information about the data rights of entrants), a copy of which
                can be found at{" "}
                <a href="http://www.costa.co.uk/privacy-policy">
                  www.costa.co.uk/privacy-policy
                </a>
                . You can request access to your personal data, or have any
                inaccuracies rectified, by sending an email to{" "}
                <a href="mailto:costadpo@costacoffee.com">
                  costadpo@costacoffee.com
                </a>
                . By participating in this promotion, you agree to the use of
                your personal data as described here.
              </li>
            </ol>
          </li>
          <li>
            <h2>GENERAL</h2>
            <ol>
              <li>
                The entry instructions form part of the Terms and Conditions. By
                entering, you agree to accept and be bound by the Terms and
                Conditions.
              </li>
              <li>
                The Promoter’s decision is final and binding. For questions
                regarding the promotion, email{" "}
                <a href="mailto:manager.costacustomerservices@costacoffee.com">
                  manager.costacustomerservices@costacoffee.com
                </a>
                .
              </li>
              <li>
                It is the responsibility of entrants to provide correct,
                up-to-date details when entering the promotion and on prize
                acceptance. The Promoter cannot be held responsible for any
                winners failing to supply accurate information or any postal
                dispute which affects prize acceptance or delivery of their
                prize.
              </li>
              <li>
                The Promoter reserves the right to verify all entries and the
                winners including but not limited to asking for proof of address
                and ID (passport, driving license or equivalent) and to refuse
                to award a prize, withdraw prize entitlement and/or refuse
                further participation in the promotion and disqualify the
                participant where there are reasonable grounds to believe there
                has been a breach of these Terms and Conditions or any
                instructions forming part of this promotions entry requirements
                or otherwise where a participant has gained unfair advantage in
                participating in the promotion or won using fraudulent means.
              </li>
              <li>
                By entering this promotion, each entrant gives the Promoter
                permission to publish their surname and county of residence if
                they are a winner unless the participant notifies them at{" "}
                <a href="mailto:manager.costacustomerservices@costacoffee.com">
                  manager.costacustomerservices@costacoffee.com
                </a>{" "}
                that they do not wish their names to be shared when they are
                contacted to redeem their prize. Please note that the Promoter
                may still be required to share this information with regulators
                (including the Advertising Standards Authority) and/or other law
                enforcement authorities, if requested to do so.
              </li>
              <li>
                If any of these clauses should be determined to be illegal,
                invalid or otherwise unenforceable then it shall be severed and
                deleted from these Terms and Conditions and the remaining
                clauses shall survive and remain in full force and effect.
              </li>
              <li>
                The promotion and these Terms and Conditions, and any dispute or
                claim arising out of or in connection with them, shall be
                governed by and construed in accordance with English law and you
                can bring legal proceedings in respect of the promotion and
                these Terms and Conditions in the English courts. If you live in
                Scotland, you will also benefit from any mandatory provisions of
                Scottish law and can bring legal proceedings in respect of the
                promotion and these Terms and Conditions in either the Scottish
                or the English courts.
              </li>
              <li>
                The Promoter is Costa Limited, 3 Knaves Beech Business Centre,
                Davies Way, Loudwater, High Wycombe, Buckinghamshire HP10 9QR.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
}
